import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'

import { PageContentUnderTitle } from 'components'
import { Table } from 'elements'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-list-view'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

const columns = [
  {
    title: 'Client Id',
    dataIndex: 'clientId',
    // render: (name, row) => (
    //   <Link to={ROUTES.OPERATOR_EDIT.replace(':clientId', row.username)}>
    //     {name}
    //   </Link>
    // ),
    sorter: (a, b) => a.clientId.localeCompare(b.clientId)
  },
  {
    title: 'Name',
    dataIndex: 'displayName',
    sorter: (a, b) => a.displayName.localeCompare(b.displayName)
  }
]

const ListView = ({ clients }) => (
  <div className={COMPONENT_CSS_CLASSNAME}>
    {clients.length > 0 && (
      <PageContentUnderTitle className={bemE('count')}>
        Showing {clients.length} clients
      </PageContentUnderTitle>
    )}
    <Table dataSource={clients} columns={columns} pagination={false} rowKey="clientId" />
  </div>
)

export default ListView



// WEBPACK FOOTER //
// ./src/pages/client/client-list/components/list-view/index.js